/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolEmptyResponse,
  SwCommentProtocolsCreateRequest,
  SwCommentProtocolsDeleteRequest,
  SwCommentProtocolsGetChildListRequest,
  SwCommentProtocolsGetChildListResponse,
  SwCommentProtocolsGetParentListRequest,
  SwCommentProtocolsGetParentListResponse,
  SwCommentProtocolsUploadAttachmentRequest,
  SwCommentProtocolsUploadAttachmentResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class SwComment<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags SwComment
   * @name GetParentListCreate
   * @request POST:/sw-comment/get-parent-list
   */
  getParentListCreate = (data: SwCommentProtocolsGetParentListRequest, params: RequestParams = {}) =>
    this.http.request<SwCommentProtocolsGetParentListResponse, any>({
      path: `/sw-comment/get-parent-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SwComment
   * @name GetChildListCreate
   * @request POST:/sw-comment/get-child-list
   */
  getChildListCreate = (data: SwCommentProtocolsGetChildListRequest, params: RequestParams = {}) =>
    this.http.request<SwCommentProtocolsGetChildListResponse, any>({
      path: `/sw-comment/get-child-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SwComment
   * @name CreateCreate
   * @request POST:/sw-comment/create
   */
  createCreate = (data: SwCommentProtocolsCreateRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/sw-comment/create`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SwComment
   * @name UploadAttachmentCreate
   * @request POST:/sw-comment/upload-attachment
   */
  uploadAttachmentCreate = (data: SwCommentProtocolsUploadAttachmentRequest, params: RequestParams = {}) =>
    this.http.request<SwCommentProtocolsUploadAttachmentResponse, any>({
      path: `/sw-comment/upload-attachment`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SwComment
   * @name DeleteCreate
   * @request POST:/sw-comment/delete
   */
  deleteCreate = (data: SwCommentProtocolsDeleteRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/sw-comment/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
